export const getDecodedBase64UrlStrings = (encodedUrl) => {
  const base64String = encodedUrl.replace(/-/g, '+').replace(/_/g, '/')
  return Buffer.from(base64String, 'base64').toString('utf-8')
}

export const getDecodedBase64UrlObjects = (appScopesParam: string) => {
  const base64String = appScopesParam.replace(/-/g, '+').replace(/_/g, '/')
  return JSON.parse(Buffer.from(base64String, 'base64').toString('utf-8'))
}
